<template>
  <div class="solution">
    <div class="solution-items">
      <div
        class="solution-item"
        v-for="(item, index) in $t('solution.items')"
        :key="index"
      >
        <img :src="getItemImage(index)" :alt="item.title" />
        <div class="title-one">{{ item.title }}</div>
        <div class="title-two">{{ item.description }}</div>
        <div class="title-three">
          <button class="solution-button" @click="goToSolutionPage(index)">
            {{ $t("slidebuttonText") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarouselPage",
  data() {
    return {
      // 定义路由名称的映射
      solutionRoutes: [
        "SolutionPage1",
        "SolutionPage2",
        "SolutionPage3",
        "SolutionPage4",
      ],
    };
  },
  methods: {
    getItemImage(index) {
      // 这里可以根据索引返回相应的图片路径
      // 例如：
      const images = [
        require("../assets/img/s1.png"),
        require("../assets/img/s2.png"),
        require("../assets/img/s3.png"),
        require("../assets/img/s4.png"),
      ];
      return images[index];
    },
    goToSolutionPage(index) {
      // 根据索引获取对应的路由名称
      const routeName = this.solutionRoutes[index];
      if (routeName) {
        // 使用路由名称进行导航
        this.$router.push({ name: routeName });
      } else {
        console.error("Route not found for index:", index);
      }
    },
  },
};
</script>

<style scoped>
.solution {
  float: left;
  width: 100%;
  text-align: center;
  background: #f6f6f6;
  padding: 0 50px 50px 50px;
  box-sizing: border-box;
}

.solution-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.solution-item {
  width: 21%;

  box-sizing: border-box;
  background: #fff;
  border: 1px solid #ededed;
  margin: 0 2%;
}

.solution-item img {
  width: 100%;
  height: auto;
}
.title-one {
  width: 100%;
  font-size: 24px;
  color: #333333;
  text-align: left;

  padding: 20px 20px 0 20px;
  box-sizing: border-box;
}
.title-two {
  width: 100%;
  font-size: 16px;
  line-height: 20px;
  color: #666666;
  text-align: left;

  padding: 10px 20px 0 20px;
  box-sizing: border-box;
}
.title-three {
  width: 100%;
  text-align: left;
  padding: 20px 20px 20px 20px;
  box-sizing: border-box;
}

.solution-button {
  background-color: #ca391b;
  color: white;
  border: none;
  padding: 10px 40px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
}

.solution-button:hover {
  background-color: #e14a2b;
}

@media (max-width: 1200px) {
  .solution {
    padding: 0;
    box-sizing: border-box;
  }
  .solution-item {
    width: 46%;
    margin: 20px 2%;
  }
  .solution-button {
    zoom: 0.8;
  }

  .title-one {
    font-size: 18px;
  }
  .title-two {
    font-size: 12px;
  }
}
</style>